import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_report_subscriptionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { only_user_subscriptions?: boolean, $top?: number, $skip?: number }): Promise<{ result?: { name?: string, created_on?: string, created_by?: string, schedule?: string, is_active?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, body?: string, schedule_name?: string, report?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { only_user_subscriptions?: boolean, $keys: string[] }): Promise<{ result?: { name?: string, created_on?: string, created_by?: string, schedule?: string, is_active?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, body?: string, schedule_name?: string, report?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      only_user_subscriptions?: boolean    }) {
      return false;
    }
}
